import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemFilter, WorkItemPort } from '../domain/workflow'

const listWorkItems = async (
	port: WorkItemPort,
	companyWorkflowId: string,
	teamId: string | null,
	notify: NotifyPort,
	filter?: WorkItemFilter,
): Promise<WorkItem[]> => {
	try {
		return await port.listByWorkflow(companyWorkflowId, teamId, filter)
	} catch {
		notify.error('workItem.itemsLoadFailed')
		return []
	}
}

export { listWorkItems }
